import { Component, OnInit, Input ,Output } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { Router } from '@angular/router';
import { ServicesProvider } from 'src/providers/services';
import { AddCall } from 'src/providers/addvCall';

@Component({
  selector: 'app-prescriptionpopup',
  templateUrl: './prescriptionpopup.page.html',
  styleUrls: ['./prescriptionpopup.page.scss'],
})


export class PrescriptionpopupPage implements OnInit {
  @Input() Address: any;
  @Output() newAddress: any;

  constructor(
    public router: Router,
    private modelcontroller: ModalController,
    private services: ServicesProvider,
    public navParams: NavParams,
    public addCall: AddCall,
  ) { }

  ngOnInit() {
    console.log('alert');
  }

  ondismiss(newAddress: any) {
    this.modelcontroller.dismiss({
      backdropDismiss: false,
      status: this.Address,
    });
  }
  
  Add_Click(){
    this.newAddress = this.Address
    this.ondismiss(this.newAddress)
  }
}
